import { Box, Typography } from '@mui/material';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import zeplinColor from 'theme/Color';
import { MENU_OPTIONS } from './data';
import { styles } from './styles';
import { MenuOptionType, OptionComponentEnum } from './types';

export const OptionMenu = ({
  anchorElement,
  onClose,
  id,
}: {
  anchorElement: SVGSVGElement | null;
  onClose: () => void;
  id: string;
}) => {
  return (
    <CustomPopOver
      onClick={(e: MouseEvent<SVGSVGElement>) => {
        e.stopPropagation();
      }}
      setAnchorEl={onClose}
      anchorEl={anchorElement}
      id={'simple-popover'}
      sx={{ ...styles.popoverContainer }}
    >
      <Box sx={{ ...styles.menuContainer }}>
        {MENU_OPTIONS.map(({ type, label, Icon, routePath }: MenuOptionType) => {
          const isLink = type === OptionComponentEnum.link;
          const component = isLink ? Link : 'button';

          const action = (id: string) => {
            return isLink && routePath ? { to: routePath(id) } : { onClick: () => {} };
          };

          return (
            <Box
              sx={{
                ...styles.optionContainer,
              }}
              key={label}
              component={component}
              {...action(id)}
            >
              <Icon />
              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                {label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </CustomPopOver>
  );
};
